import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
import { BaseService } from './base.service'

export class MdService extends BaseService {
  static async fetch(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.md.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getByUser(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.md.get-by-user'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async create(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.md.init'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async update(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.md.update'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
}
